import { render, staticRenderFns } from "./DriverTestimonialQuote.vue?vue&type=template&id=a85e84b0&scoped=true&"
import script from "./DriverTestimonialQuote.vue?vue&type=script&lang=js&"
export * from "./DriverTestimonialQuote.vue?vue&type=script&lang=js&"
import style0 from "./DriverTestimonialQuote.vue?vue&type=style&index=0&id=a85e84b0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a85e84b0",
  null
  
)

export default component.exports